import React from 'react';
import { Link } from 'react-router';
import selectn from 'selectn';
import classNames from 'classnames';
import ProviderSettings from './ProviderSettings';

/* eslint-disable */
const isChromeOrSafari = () => {
    if (typeof window !== 'undefined') {
        const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        const isChrome = !!window.chrome && !!window.chrome.webstore;
        return isSafari || isChrome;
    }
    return false;
}
/* eslint-enable */

const ProviderLogoPlayback = ({
    displayLogout,
    handleLogin,
    handleLogout,
    hideProviderLogo,
    loggedIn,
    providerInfo,
    watchLogo
}) => {
    const headerClass = classNames('playback__header', {
        'playback__header--loggedIn': loggedIn
    });

    const imgSrc = selectn('images.colorWithNegativeBackground.href', providerInfo) ||
        selectn('images.logo.href', providerInfo) || '';
    const webLink = selectn('links.web.href', providerInfo) || '/watch';

    let target = '';
    let imgStyle = {};
    // hack for browser inconsistencies of rendering svgs in images
    if (isChromeOrSafari()) {
        imgStyle = {
            width: 'auto'
        };
    }
    const providerImg = imgSrc ? <img src={imgSrc} className="imageLoaded" style={imgStyle} alt="Provider" /> : null;
    if (providerImg !== null) {
        target = '_blank';
    }

    let providerLogoEl = null;
    let providerSettingsEl = null;
    if (!hideProviderLogo) {
        providerLogoEl = (
            <div className="playback__provider">
                <a className="playback__logo__link" target={target} href={webLink}>
                    <picture>
                        {providerImg}
                    </picture>
                </a>
            </div>
        );
        providerSettingsEl = (
            <ProviderSettings
                displayLogout={displayLogout}
                handleLogin={handleLogin}
                handleLogout={handleLogout}
                providerInfo={providerInfo}
            />
        );
    }

    return (
        <header className={headerClass}>
            <div className="playback__logo">
                <Link data-route="false" className="playback__logo__link" to="/">
                    <picture>
                        <img src={watchLogo} className="imageLoaded" alt="Watch ESPN" />
                    </picture>
                </Link>
            </div>
            {providerLogoEl}
            {providerSettingsEl}
        </header>
    );
};

ProviderLogoPlayback.propTypes = {
    displayLogout: React.PropTypes.bool,
    handleLogin: React.PropTypes.func,
    handleLogout: React.PropTypes.func,
    hideProviderLogo: React.PropTypes.bool,
    loggedIn: React.PropTypes.bool,
    providerInfo: React.PropTypes.object,
    watchLogo: React.PropTypes.string
};

ProviderLogoPlayback.defaultProps = {
    providerInfo: {}
};

export default ProviderLogoPlayback;



// WEBPACK FOOTER //
// ./app/branding/ProviderLogoPlayback.js